import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const MANAGEMENT_ENDPOINT = {
  CREATE_TAG: {
    method: EMethod.POST,
    url: "/management/tag",
    version: API_VERSION.V0,
  },
  GET_TAG: {
    method: EMethod.GET,
    url: "/management/tag/list",
    version: API_VERSION.V0,
  },
  UPDATE_TAG: {
    method: EMethod.PATCH,
    url: "/management/tag",
    version: API_VERSION.V0,
  },
  DELETE_TAG: {
    method: EMethod.DEL,
    url: "/management/tag",
    version: API_VERSION.V0,
  },
  GET_USERS_PIPELINES: {
    method: EMethod.GET,
    url: "/management/pipeline",
    version: API_VERSION.V0,
  },
  GET_NOTES_HISTORY: {
    method: EMethod.POST,
    url: "/management/notes/{entityType}/{entityId}",
    version: API_VERSION.V0,
  },
  GET_USERS_PIPELINE_STATUS_LIST: {
    method: EMethod.GET,
    url: "/management/pipeline/status/{pipelineSlug}",
    version: API_VERSION.V0,
  },
  GET_TICKET_LIST: {
    method: EMethod.POST,
    url: "/management/ticket/list",
    version: API_VERSION.V0,
  },
  GET_STAFF_ALL_TAG_LIST: {
    method: EMethod.POST,
    url: "/management/general/staff-tag/list",
    version: API_VERSION.V0,
  },
  GET_TICKET_LIST_GLOBAL: {
    method: EMethod.POST,
    url: "/management/ticket/list/global",
    version: API_VERSION.V0,
  },
  GET_BU_SCORECARD_HISTORY_STAFF: {
    method: EMethod.POST,
    url: "/management/scorecards/business-unit/list/staff",
    version: API_VERSION.V0,
  },
  GET_BU_SCORECARD_HISTORY_CORPORATION: {
    method: EMethod.POST,
    url: "/management/scorecards/business-unit/list/corporation",
    version: API_VERSION.V0,
  },
  GET_KANBAN_TICKETS: {
    method: EMethod.POST,
    url: "/management/pipeline/kanban/{pipelineSlug}",
    version: API_VERSION.V0,
  },
  UPDATE_SCORECARD_STAFF: {
    method: EMethod.PATCH,
    url: "/management/scorecards/staff/{idScorecard}",
    version: API_VERSION.V0,
  },
  UPDATE_SCORECARD_CLIENT: {
    method: EMethod.PATCH,
    url: "/management/scorecards/client/{idScorecard}",
    version: API_VERSION.V0,
  },
  GET_SCORECARD_DETAILS: {
    method: EMethod.GET,
    url: "/management/scorecards/{idScorecard}",
    version: API_VERSION.V0,
  },
  GET_TICKET_DETAIL: {
    method: EMethod.GET,
    url: "/management/ticket/{pipelineSlug}/{idTicket}",
    version: API_VERSION.V0,
  },
  GET_USER_APP_ACCESS_RIGHT: {
    method: EMethod.GET,
    url: "/management/access-right",
    version: API_VERSION.V0,
  },
};
